module.exports = __webpack_public_path__ + "img/w3_delivery_white.70d83d45.png";